import { Dictionary } from './types';

const MASKS_CONVERT = {
  HyphensAndUnderscoresWithSmallLetters: /([-_][a-z])/gi,
  Uppercase: /([A-Z])/g,
};

export function toCamelOrSnakeCase<T>(
  dictionary: Dictionary | Dictionary[],
  isCamelCase: boolean,
): T {
  if (Array.isArray(dictionary)) {
    if (typeof dictionary[0] === 'string') {
      return dictionary as T; 
    }
    return dictionary.map((item) => toCamelOrSnakeCase<T>(item, isCamelCase)) as T;
  }

  if (typeof dictionary !== 'object' || dictionary === null) {
    return dictionary as T;
  }

  const newDictionary: Dictionary = {};

  Object.keys(dictionary).forEach((key) => {
    const newKey = isCamelCase
      ? key.replace(
        MASKS_CONVERT.HyphensAndUnderscoresWithSmallLetters,
        ($1) => $1.toUpperCase().replace('-', '').replace('_', ''),
      )
      : key.replace(MASKS_CONVERT.Uppercase, '_$1').toLowerCase();

    const value = dictionary[key];

    if (Array.isArray(value) && value.every((item) => typeof item === 'string')) {
      newDictionary[newKey] = value;
    }
    else if (typeof value === 'object' && value !== null) {
      newDictionary[newKey] = toCamelOrSnakeCase(value, isCamelCase);
    }
    else {
      newDictionary[newKey] = value;
    }
  });

  return newDictionary as T;
}
